export const ENDPOINTS = {
  updatePackConfiguration: '/gateway/extranet/:id/packs/:packId',
  savePackInventory: '/gateway/extranet/:id/packs/:packId/inventory',
  updatePricingConfiguration: '/gateway/extranet/:id/packs/:packId',
  getDiscountAllocation: '/gateway/extranet/:id/discount-allocation/room-price',
  saveDiscountAllocation: '/gateway/extranet/:id/discount-allocation',
  getPackages: '/gateway/extranet/:hotelId/packages',
} as const;

export const CORE_QUERY_KEYS = {
  discountAllocation: 'extranet-discount-allocation',
  packages: 'extranet-packages',
} as const;
